module.exports = __webpack_public_path__ + "img/3-4.67ff8bb8.svg";